export default __webpack_public_path__ + "static/product-background-1cd0814c5be9915f0116a309275fcdc0.png";